import Navbar from "../components/sections/Navbar";
import Breadcrumb from "../components/ui/Breadcrumb";
import PageHeader from "../components/sections/PageHeader";
import Divider from "../components/ui/Divider";
import SettingsPanel from "../components/sections/SettingsPanel"

function Settings() {

    return (
        <div>
            <Navbar />
            <div className="container">
                <Breadcrumb icon="home-line.png" items={["Accounts", "Gebruiker toevoegen"]} current="Instellingen" />
                <PageHeader title="Instellingen" />
                <Divider mb={20}/>
                <SettingsPanel/>
            </div>
        </div>
    );
}

export default Settings;